import { useEffect, useRef } from 'react';

export const useArrayMemo = <T>(array: T[]) => {
  const ref = useRef<T[]>();

  const same =
    !!ref.current &&
    array.length === ref.current.length &&
    array.every((el, i) => el === (ref.current && ref.current[i]));

  useEffect(() => {
    if (!same) ref.current = array;
  }, [same, array]);

  return same ? ref.current : array;
};
